import { CardSlider } from '../../__utils/sliders';

// GLOBAL APP CONTROLLER
const controller = {
    init() {
        CardSlider.init();

        if (window.acf) {
            window.acf.addAction( 'render_block_preview/type=card-slider', function() {
                CardSlider.init();
            } );
        }
    },
    loaded() {},
    resized() {},
    scrolled() {},
    keyDown(e) {},
    scrolled() {},
    keyDown(e) {},
    mouseUp(e) {},
};
export default controller;
